<template>
    <el-dialog @close='closeDialog' title="添加商品" :visible.sync="dialogVisible">
        <div class="add_goods_box">
            <div class="add_goods_search_box">
                <el-input placeholder="输入商品名称" v-model="searchGoodsName" clearable></el-input>
                <el-button type="primary" @click="addGoodsSearch" plain>搜索</el-button>
            </div>
            <div class="add_goods_tabs_box">
                <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
                    <el-tab-pane :label="item.label" :name="item.name" v-for="(item,index) in activeList" :key="index">
                        <el-table v-loading="loading" :data="tableData" style="width: 100%" :show-header="false" @select="handleSelectionChange" :ref="'multipleTable'+item.name" max-height="300">
                        <!-- <el-table :data="tableData" style="width: 100%" :show-header="false" @select="handleSelectionChange" :ref="'multipleTable'+item.name" max-height="300"> -->
                            <el-table-column type="selection" width="28"></el-table-column>
                            <el-table-column label="商品信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <img v-lazy="scope.row.logoPic.furl" alt>
                                        <div>
                                            <p>{{scope.row.kmcname}}</p>
                                            <p :class="scope.row.isFree === 1 ? 'free' : 'toll'">{{scope.row.isFree === 1 ? scope.row.isFreeText : scope.row.saleprice}}</p>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureAdd()">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {findGoodsList, addGoods} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'addGoodsTip',
    props: ['addGoodsData'],
    data() {
        return {
            flag: true,
            page: {
                page: 0,
                pageSize: 10,
                pageCount: 0
            },
            scrollTop: 0, // 上一次滚动距离
            tableData: [],
            dialogVisible: false,
            searchGoodsName: '',
            // activeList: [{label: '图文', name: 'tuwen'}, {label: '报告', name: 'baogao'}, {label: '视频', name: 'shipin'}, {label: '专题', name: 'zhuanti'}],
            activeList: [{label: '课程', name: 'kecheng'}, {label: '报告', name: 'baogao'}, {label: '直播', name: 'zhibo'}],
            goodsType: 7, // 商品类型
            multipleSelection: [],
            activeName: 'kecheng',
            loading: false
        }
    },
    mounted() {},
    methods: {
        // 打开弹窗
        openDialog(selectedResult) {
            this.loading = true
            this.tableData = []
            this.dialogVisible = true
            this.getGoodsTypeList(this.goodsType)
        },
        // 关闭弹框
        closeDialog() {
            this.page = {
                page: 0,
                pageSize: 10,
                pageCount: 0
            }
            this.multipleSelection = []
            this.flag = true
            this.dialogVisible = false
            this.searchGoodsName = ''
        },
        // 添加分组弹窗Tabs
        handleClick(tabName) {
            switch (tabName) {
            // case 'tuwen':
            //     this.goodsType = 1
            //     break
            // case 'baogao':
            //     this.goodsType = 2
            //     break
            // case 'shipin':
            //     this.goodsType = 4
            //     break
            // case 'zhuanti':
            //     this.goodsType = 5
            //     break
            // }
            case 'kecheng': 
                this.goodsType = 7
                break
            case 'baogao': 
                this.goodsType = 2
                break
            case 'zhibo': 
                this.goodsType = 3
                break
            }
            this.searchGoodsName = ''
            this.loading = true
            this.tableData = []
            this.page.page = 0
            this.flag = true
            this.getGoodsTypeList(this.goodsType)
        },
        // 获取不同类型下商品列表
        getGoodsTypeList(type, rows) {
            let selectedResult = this.multipleSelection
            if (this.flag) {
                this.page.page++
                // this.setLoading(true)
                var params = {
                    divisioninnerid: this.$route.query.innerid,
                    kmctype: type
                }
                findGoodsList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        // this.setLoading(false)
                        this.tableData = this.tableData.concat(data.data.content)
                        this.page.pageCount = data.data.pageinfo.pageCount
                        if (selectedResult.length) {
                            console.log(selectedResult)
                            this.tableData.forEach(obj1 => {
                                selectedResult.forEach(obj2 => {
                                    this.$nextTick(() => {
                                        this.$refs[`multipleTable${this.activeName}`][0].toggleRowSelection(obj2)
                                    })
                                })
                            })
                        }
                        this.loading = false
                        let _this = this
                        this.$nextTick(() => {
                            $('.el-table__body-wrapper').scroll(function () {
                                let scrollTop = Math.floor(this.scrollTop)
                                let clientHeight = this.clientHeight
                                let scrollHeight = Math.floor(this.scrollHeight)
                                // console.log(scrollTop, clientHeight, scrollHeight, _this.scrollTop)
                                if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                    _this.scrollTop = this.scrollTop
                                    if (_this.page.page < _this.page.pageCount) {
                                        _this.getGoodsTypeList(_this.goodsType)
                                    }
                                }
                            })
                        })
                    },
                    error: data => {
                        console.log('error：', data)
                        // this.setLoading(false)
                    }
                })
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
            console.log(this.multipleSelection)
        },
        // 添加商品弹窗内搜索按钮
        addGoodsSearch() {
            // this.setLoading(true)
            this.loading = true
            var params = {
                divisioninnerid: this.$route.query.innerid,
                kmcname: this.searchGoodsName,
                kmctype: this.goodsType
            }
            findGoodsList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    // this.setLoading(false)
                    this.tableData = data.data.content
                    this.loading = false
                },
                error: data => {
                    // this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 确定添加商品
        sureAdd() {
            if (this.multipleSelection.length === 0) {
                this.$message.error(`请选择需要添加的商品！`)
                return
            }
            var goodsIds = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
                goodsIds.push(this.multipleSelection[i].kmcinnerid)
            }
            this.setLoading(true)
            var params = {
                divisioninnerid: this.$route.query.innerid,
                kmcinnerid: goodsIds.join(','),
                kmctype: this.goodsType
            }
            addGoods({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.dialogVisible = false
                    this.$message.success(`添加成功！`)
                    this.$emit('getGoodsGroupInfo')
                },
                error: data => {
                    this.setLoading(false)
                    this.dialogVisible = false
                    console.log('error：', data)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .add_goods_box {
        .add_goods_search_box {
            display: flex;
            margin-bottom: 10px;
            .el-input {
                width: 240px;
            }
            .el-input__inner {
                height: 36px;
            }
            .el-input__icon {
                line-height: 36px;
            }
            .el-button,
            .el-button--mini {
                height: 36px;
                width: 96px;
                margin-left: 20px;
                margin-bottom: 0px;
            }
        }
        .add_goods_tabs_box {
            .goods_item_box {
                display: flex;
                align-items: center;
                & > img {
                    width: 74px;
                    min-width: 74px;
                    height: 42px;
                    margin-right: 10px;
                }
                & > div {
                    & > p:nth-of-type(1) {
                        color: rgba(48, 49, 51, 1);
                        line-height: 18px;
                        margin-bottom: 4px;
                        width: 420px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    & > p:nth-of-type(2) {
                        line-height: 20px;
                    }
                    .free {
                        color: rgba(64, 158, 255, 1);
                    }
                    .toll {
                        color: #f56c6c;
                    }
                }
            }
            .el-table__empty-block {
                max-height: 340px;
            }
            .el-table__empty-text {
                position: relative;
                top: 80px;
            }
        }
        .el-tabs__header {
            padding-right: 20px;
        }
        .el-tabs__content {
            height: 300px;
            padding-right: 14px;
        }
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 6px;
        }
        .el-table__body-wrapper::-webkit-scrollbar-thumb {
            border-radius: 5px;
            background: #909399;
        }
        .el-table__body-wrapper::-webkit-scrollbar-track {
            border-radius: 5px;
            background-color: rgba(255, 255, 255, 0.1);
        }
        .el-table {
            .el-table-column--selection {
                .cell {
                    padding-left: 0;
                    padding-right: 0;
                    text-align: right;
                }
            }
        }
    }
</style>
